import { HttpClient } from '@angular/common/http';
import { importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { TitleStrategy } from '@angular/router';

import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocalizedTitleStrategy } from './title.strategy';

const setupTranslate = (): void => {
  const translate = inject(TranslateService);
  translate.setDefaultLang('ru');
  translate.use('ru');
};

const httpLoaderFactory = () => {
  return new TranslateHttpLoader(inject(HttpClient), './assets/i18n/', '.json');
};

export const providersTranslate = [
  provideAppInitializer(setupTranslate),
  importProvidersFrom([
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ]),
  {
    provide: TitleStrategy,
    useClass: LocalizedTitleStrategy,
  },
];
